// Local Storage
export const LocalStorage = {
  storage: window.localStorage,

  /** 存储数据 */
  set(key, value) {
    if (typeof value === "string") {
      this.storage.setItem(key, value);
      return;
    }

    try {
      this.storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error("存储数据失败：", error);
    }
  },

  /** 获取数据 */
  get(key, isJson = true) {
    const value = this.storage.getItem(key);
    if (!value) return null;

    if (!isJson) return value;
    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  },

  /** 删除数据 */
  remove(key) {
    this.storage.removeItem(key);
  },

  /** 清空数据 */
  clear() {
    this.storage.clear();
  }
}

/**
 * Set storage
 *
 * @param name
 * @param content
 * @param maxAge
 */
export const setStorage = (name, content, maxAge = null) => {
  if (!global.window || !name) {
    return;
  }

  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }

  const storage = global.window.sessionStorage;

  storage.setItem(name, content);
  if (maxAge && !Number.isNaN(parseInt(maxAge, 10))) {
    const timeout = parseInt(new Date().getTime() / 1000, 10);
    storage.setItem(`${name}_expire`, timeout + maxAge);
  }
};

/**
 * Get storage
 *
 * @param name
 * @returns {*}
 */
export const getStorage = (name) => {
  if (!global.window || !name) {
    return;
  }

  const content = window.sessionStorage.getItem(name);
  const _expire = window.sessionStorage.getItem(`${name}_expire`);

  if (_expire) {
    const now = parseInt(new Date().getTime() / 1000, 10);
    if (now > _expire) {
      return;
    }
  }

  try {
    // eslint-disable-next-line consistent-return
    return JSON.parse(content);
  } catch (e) {
    // eslint-disable-next-line consistent-return
    return content;
  }
};

/**
 * Clear storage
 *
 * @param name
 */
export const removeStorage = (name) => {
  if (!global.window || !name) {
    return;
  }

  window.sessionStorage.removeItem(name);
  window.sessionStorage.removeItem(`${name}_expire`);
};

/**
 * Clear all storage
 */
export const clearStorage = (name) => {
  if (!global.window || !name) {
    return;
  }

  window.sessionStorage.clear();
};
